import React from 'react';
import './ThankYouPage.css';

const ThankYouPage= () => {
  return (
    <div className="thankyou-container">
      <h1 className="thankyou-title">¡Gracias por tu participación!</h1>
      <p className="thankyou-message">
        Has contestado correctamente la encuesta. Ya puedes cerrar esta ventana.
      </p>
      <button
        className="close-button"
        onClick={() => window.close()}
      >
        Cerrar ventana
      </button>
    </div>
  );
}

export default ThankYouPage;
